import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import Aura from '@/assets/styles/primevuePreset';
import App from '@/App/App.vue';
import router from './router';
import '@/assets/styles/bootstrap.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Collapse from 'bootstrap/js/src/collapse.js';
import Dropdown from 'bootstrap/js/src/dropdown.js';
import Modal from 'bootstrap/js/src/modal.js';
import Offcanvas from 'bootstrap/js/src/offcanvas.js';
window.bootstrap = { Collapse, Dropdown, Modal, Offcanvas };
import './style.css';
import ToastService from 'primevue/toastservice'; 
import 'primeicons/primeicons.css'
import Toast from 'primevue/toast';
import Tooltip from 'primevue/tooltip';
import user from '@/services/Auth/authInstance';
import AuthService from '@/services/Auth/AuthService';
import emitter from '@/eventBus';
import { useLoaderStore } from '@/stores/loader';
import '@/assets/styles/fonts.css';
import {
  getPrimeVueLocale,
  i18n,
  initializeLocale,
  LOCALE_CHANGED_EVENT,
} from '@/i18n';

/**
 * Создаёт основное приложение Vue и настраивает его плагины и глобальные свойства.
 */
// Отключаем нативное восстановление скролла (Chrome/Safari/Firefox)
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
async function bootstrapApp() {
  await initializeLocale();
  const app = createApp(App);
  const pinia = createPinia();

  window.app = app;
  app.config.globalProperties.$emitter = emitter;
  app.config.globalProperties.$user = user;

  (async () => {
    const token = user.getToken();
    if (!token) return; // ничего не делаем

    try {
      // /users/me вернёт 401, если токен протух
      const me = await AuthService.getMe();
      user.fromObject(me); // обновим кэш, если всё ок
      user.updateCache();
    } catch (e) {
      // токен невалиден → выходим
      user.logout();
    }
  })();

  app.use(pinia);

  const loader = useLoaderStore();
  app.config.globalProperties.$loader = loader;

  app.use(router);
  app.use(i18n);
  app.use(ToastService);
  app.use(PrimeVue, {
    locale: getPrimeVueLocale(),
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: '.my-app-dark',
        cssLayer: false
      }
    }
  });
  window.addEventListener(LOCALE_CHANGED_EVENT, (event) => {
    app.config.globalProperties.$primevue.config.locale = getPrimeVueLocale(event.detail.locale);
  });
  app.component('Toast', Toast); // ← чтобы можно было использовать <Toast />
  app.directive('tooltip', Tooltip);
  /**
   * Монтирует Vue-приложение в DOM.
   */
  app.mount('#app');
}

bootstrapApp().catch(error => console.error('[App] Failed to initialize', error));
